// config/routeConfig.jsx
import { ACCESS } from "../utils/constants";

// Lazy imports za code splitting
import { lazy } from "react";

// Public pages
const HomePage = lazy(() => import("../pages/HomePage/HomePage"));
const AboutUs = lazy(() => import("../pages/AboutUs/AboutUs"));
const Workshops = lazy(() => import("../pages/Workshops/Workshops"));
const Metod45 = lazy(() => import("../pages/Metod45/Metod45"));
const Sets = lazy(() => import("../pages/Sets/Sets"));
const SetDetails = lazy(() => import("../pages/SetDetails/SetDetails"));
const Experiences = lazy(() => import("../pages/Experiences/Experiences"));
const Contact = lazy(() => import("../pages/Contact/Contact"));
const PrivacyPolicy = lazy(
  () => import("../pages/PrivacyPolicy/PrivacyPolicy"),
);
const TermsAndConditions = lazy(
  () => import("../pages/TermsAndConditions/TermsAndConditions"),
);

// Auth pages
const Login = lazy(() => import("../pages/Auth/Login"));
const Register = lazy(() => import("../pages/Auth/Register"));
const EmailVerification = lazy(() => import("../pages/Auth/EmailVerification"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));

// User pages
const MySets = lazy(() => import("../pages/Dashboard/MySets"));
const MyWorkshops = lazy(() => import("../pages/Dashboard/MyWorkshops"));
const MySetDetails = lazy(() => import("../pages/Dashboard/MySetDetails"));
const Settings = lazy(() => import("../pages/Dashboard/Settings"));

// Admin pages
const AdminOverview = lazy(
  () => import("../pages/AdminDashboard/AdminOverview"),
);
const AdminUsers = lazy(() => import("../pages/AdminDashboard/AdminUsers"));
const AdminOrders = lazy(() => import("../pages/AdminDashboard/AdminOrders"));
const AdminWorkshops = lazy(
  () => import("../pages/AdminDashboard/AdminWorkshops"),
);
const AdminSets = lazy(() => import("../pages/AdminDashboard/AdminSets"));
const CreateSet = lazy(() => import("../pages/AdminDashboard/CreateSet"));
const EditSet = lazy(() => import("../pages/AdminDashboard/EditSet"));
const SetDetail = lazy(() => import("../pages/AdminDashboard/SetDetail"));
const AdminNavigator = lazy(
  () => import("../pages/AdminDashboard/AdminNavigator"),
);

export const publicRoutes = [
  { path: "/", element: <HomePage /> },
  { path: "/o-nama", element: <AboutUs /> },
  { path: "/recepti-za-roditeljstvo", element: <Workshops /> },
  { path: "/recepti-za-roditeljstvo/:sku", element: <Workshops /> },
  { path: "/metod-45", element: <Metod45 /> },
  { path: "/setovi", element: <Sets /> },
  { path: "/setovi/pregled/:id", element: <SetDetails /> },
  { path: "/iskustva", element: <Experiences /> },
  { path: "/kontakt", element: <Contact /> },
  { path: "/privatnost", element: <PrivacyPolicy /> },
  { path: "/uslovi", element: <TermsAndConditions /> },
];

export const authRoutes = [
  { path: "/prijava", element: <Login />, access: ACCESS.PUBLIC },
  { path: "/registracija", element: <Register />, access: ACCESS.PUBLIC },
  {
    path: "/verifikacija-email",
    element: <EmailVerification />,
    access: ACCESS.PUBLIC,
  },
  {
    path: "/zaboravljena-lozinka",
    element: <ForgotPassword />,
    access: ACCESS.PUBLIC,
  },
  {
    path: "/promena-lozinke",
    element: <ResetPassword />,
    access: ACCESS.PUBLIC,
  },
];

export const userRoutes = [
  { path: "/korisnicki-panel/moji-setovi", element: <MySets /> },
  { path: "/korisnicki-panel/moje-radionice", element: <MyWorkshops /> },
  { path: "/korisnicki-panel/set/:id/:title", element: <MySetDetails /> },
  { path: "/korisnicki-panel/podesavanja", element: <Settings /> },
].map((route) => ({ ...route, access: ACCESS.USER_ONLY }));

export const adminRoutes = [
  {
    path: "/admin-panel/pregled",
    element: <AdminOverview />,
    access: ACCESS.ADMIN,
  },
  {
    path: "/admin-panel/korisnici",
    element: <AdminUsers />,
    access: ACCESS.ADMIN,
  },
  {
    path: "/admin-panel/porudzbine",
    element: <AdminOrders />,
    access: ACCESS.ADMIN,
  },
  {
    path: "/admin-panel/radionice",
    element: <AdminWorkshops />,
    access: ACCESS.ADMIN,
  },
  {
    path: "/admin-panel/navigator",
    element: <AdminNavigator />,
    access: ACCESS.ADMIN,
  },
  {
    path: "/admin-panel/setovi",
    element: <AdminSets />,
    access: ACCESS.SUPER_ADMIN,
  },
  {
    path: "/admin-panel/setovi/kreiranje",
    element: <CreateSet />,
    access: ACCESS.SUPER_ADMIN,
  },
  {
    path: "/admin-panel/setovi/uređivanje/:id",
    element: <EditSet />,
    access: ACCESS.SUPER_ADMIN,
  },
  {
    path: "/admin-panel/setovi/pregled/:id",
    element: <SetDetail />,
    access: ACCESS.SUPER_ADMIN,
  },
];
